(function($, undefined) {

	'use strict';
	var mapOuterCtn;

	var initMap = function() {
		mapOuterCtn.each(function(index) {
			var id = $(this).attr('data-id');
			var mapCtn = $(this).find('.contact-ver1-middle-ctn');
			var map;
			var geocoder;
			var marker;
			var address = $(this).find('.contact-address').html();

			if (address.length === 0) {
				return;
			}

			var mapOptions = {
				zoom: 16,
				disableDefaultUI: true,
			};

			geocoder = new google.maps.Geocoder();
			geocoder.geocode({
				'address': address
			}, function(results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					mapOptions.center = results[0].geometry.location;
					map = new google.maps.Map(document.getElementById('map-'+ id), mapOptions);
					marker = new google.maps.Marker({
						map: map,
						position: results[0].geometry.location,
					});
				}
			});
		});
	};

	var init = function() {
		mapOuterCtn = $('.contact-ctn.ver1');

		if ($('.contact-address').length && mapOuterCtn.length) {
			initMap();
		}
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);

